import styled from 'styled-components'

export const PaginationWrap = styled.div`
    display: flex;
    justify-content: center;
    padding: 24px 0 8px;
    border-top: 1px solid #e8edf4;
    margin-top: 16px;
`
